import { put, all, select } from "redux-saga/effects";
import { cloneDeep } from "lodash";

import getErrorActions from "rdx/utils/getErrorActions";
import makeRequest from "rdx/utils/makeRequest";
import actions from "rdx/actions";
import preSalesSelectors from "rdx/modules/projectPreSales/selectors";
import { keysToCamelCase } from "lib/helpers";
import messages from "../messages";

function* closeLead(action) {
  const { id, closeReasonId, closeNote } = action.payload;
  const params = {
    close_reason_id: closeReasonId,
    close_note: closeNote,
  };

  const { success, data, error } = yield* makeRequest.post(`/leads/${id}/close`, params);

  if (success && data) {
    const leadDetails = keysToCamelCase(data.body);
    const { projects: presalesProjects, paging: presalesPaging } = yield select(preSalesSelectors.getProjectPreSales);
    const idxOfUpdatedLead = presalesProjects.findIndex((proj) => proj.leadId === parseInt(id, 10));
    const updatedPreSales = cloneDeep(presalesProjects);
    updatedPreSales[idxOfUpdatedLead] = {
      ...updatedPreSales[idxOfUpdatedLead],
      closeAt: leadDetails.closeAt,
      closeReasonId: leadDetails.closeReasonId,
    };

    yield all([
      put(actions.setLeadDetails(leadDetails)),
      put(
        actions.setProjectsPreSales({
          projects: updatedPreSales,
          paging: presalesPaging,
        }),
      ),
      put(
        actions.newSuccessEvent({
          message: messages.CLOSE_LEAD_SUCCESS,
        }),
      ),
    ]);
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_CLOSING_LEAD,
    });
  }
  return null;
}

export default closeLead;
